// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAccountInfo } from './IAccountInfo';
import {
    IAccountInfoFromJSON,
    IAccountInfoFromJSONTyped,
    IAccountInfoToJSON,
    IAccountInfoToJSONTyped,
} from './IAccountInfo';

/**
 * 
 * @export
 * @interface IAddVaultedAccountResponse
 */
export interface IAddVaultedAccountResponse {
    /**
     * 
     * @type {Array<IAccountInfo>}
     * @memberof IAddVaultedAccountResponse
     */
    accounts?: Array<IAccountInfo>;
}

/**
 * Check if a given object implements the IAddVaultedAccountResponse interface.
 */
export function instanceOfIAddVaultedAccountResponse(value: object): value is IAddVaultedAccountResponse {
    return true;
}

export function IAddVaultedAccountResponseFromJSON(json: any): IAddVaultedAccountResponse {
    return IAddVaultedAccountResponseFromJSONTyped(json, false);
}

export function IAddVaultedAccountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAddVaultedAccountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'accounts': json['accounts'] == null ? undefined : ((json['accounts'] as Array<any>).map(IAccountInfoFromJSON)),
    };
}

export function IAddVaultedAccountResponseToJSON(json: any): IAddVaultedAccountResponse {
    return IAddVaultedAccountResponseToJSONTyped(json, false);
}

export function IAddVaultedAccountResponseToJSONTyped(value?: IAddVaultedAccountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accounts': value['accounts'] == null ? undefined : ((value['accounts'] as Array<any>).map(IAccountInfoToJSON)),
    };
}

